import React, { Component } from 'react';
import './Clientes.css';
import { getClients, getClientsByNIF } from '../../services/clients';
import { Input, Icon } from 'element-react';

class Clientes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      clients: [],
      clientFilterNIF: '',
    };
  }

  componentDidMount() {
    this.getClients();
  }

  async getClients() {
    try {
      const { data: { clients } } = await getClients();
      this.setState({ clients, loading: false });
    } catch (err) {
      console.error(err);
    }
  }

  async getClientsNIF(val) {
    try {
      const { data: { clients } } = await getClientsByNIF(val);
      this.setState({ clients, loading: false });
    } catch (err) {
      console.error(err);
    }
  }

  filterChange(val) {
    this.setState({ clientFilterNIF: val, loading: true });

    if (val && val.length > 0) this.getClientsNIF(val);
    else this.getClients(val);
  }

  renderFilters() {
    return (
      <div className="clientsFilters">
        <div className="clientsFilter">
          <p>Buscar por DNI:</p>
          <Input placeholder="Escribir NIF del cliente..." value={this.state.clientFilterNIF} onChange={val => this.filterChange(val)}/>
        </div>
      </div>
    );
  }

  renderClients() {
    return (
      <div className="clientsList">
        { this.state.clients.length > 0
            ? this.state.clients.map((client, index) => (
                <div key={index} className="clientsItem">
                  <p>Nom: { client.name }</p>
                  <p>NIF: { client.nif }</p>
                  <p>Direcció: { client.dir }</p>
                  <p className="bordered">Ha vingut { client.count } vegades:</p>
                  { 
                    client.checkInDate.map((date, subindex) => (
                      <div style={{ marginLeft: 10 }}>
                        <p>{subindex + 1})</p>
                        <div style={{ marginLeft: 10 }}>
                          <p key={date}>Check-in: { `${new Date(date).getDate()}/${new Date(date).getMonth() + 1}/${new Date(date).getFullYear()}`}</p>
                          <p>Reserva #: { this.state.clients[index].bookingId[subindex] }</p>
                        </div>
                      </div>
                    ))
                  }
                </div>
              ))
            : <p>No s'han trobat clients.</p>
        }
      </div>
    );
  }

  render() {
    return (
      <div className="clientesWrapper">
        { this.renderFilters() }

        { 
          this.state.loading
            ? <Icon name={'loading'} style={{ padding: 8 }} />
            : this.renderClients() 
        }
      </div>
    );
  }
}

export default Clientes;



// WEBPACK FOOTER //
// ./src/components/Clientes/Clientes.js